export default __webpack_public_path__ + "static/media/HCPManagement.126605de.svg";